<template>
  <ul class="pointData">
    <li :key="i" v-for="(data,i) in pointDataList">

      <div :style="{borderColor: data.status===0 ? 'rgba(255, 0, 0, .8)' : 'rgba(41, 155, 255, .3)'}"
           style="border: 1px solid rgba(41, 155, 255, .3);width: 100%;height: 117px;">
        <div style="width: 40%;height: 100%;float: left;text-align: center;padding-top: 15px;">
          <img src="../../../assets/images/icon/battery.png">
          <div class="text-blueGrey">编号{{ data.parentId }}</div>
        </div>
        <div style="padding-top: 5px;">
          <div :key="item.id" style="margin-top: 10px;" v-for="item in data.list">
            <span :style="{color: item.status===0 ? 'red' : '#fff'}">{{ item.pointName }}: {{
                item.pointValueName
              }}</span>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "GroupPointLayout",
  props: {
    pointData: {
      type: Array,
      default: () => []
    },
    alarmPointIdList: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: '240px'
    }
  },
  data() {
    return {
      pointDataList: this.pointData.map(item => ({...item}))
    }
  },
  watch: {
    pointData: {
      handler(val) {
        this.pointDataList = val
      }
    },
    alarmPointIdList: {
      handler(val) {
        if (val.length > 0) {
          this.pointDataList = this.pointData.map(item => {
            item.status = 1;
            item.list = item.list.map(group => {
              val.forEach(pointId => {
                if (group.pointId === pointId) {
                  group.status = 0;
                  item.status = 0;
                }
              })
              return group;
            })
            return item;
          })
        }
      }
    }
  },
}
</script>

<style scoped>
ul.pointData {
  padding-left: 0;
}

.pointData li {
  width: 210px;
  list-style: none;
  display: inline-block;
  margin: 15px 30px;
}
</style>
